import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { useEffect, useRef, useState } from "react";
import 'HELPDESK/CommonResources/NotificationPanel/NotificationPanel.css';
// import CHECK from './images/check.svg';
// import DOUBLE_CHECK from './images/double-check.svg';
import config from "config";
import HelpdeskApiCall from 'HelpdeskApiCall';
import { useDispatch, useSelector } from 'react-redux';
import CHECK from './images/check.svg';
import DOUBLE_CHECK from './images/double-check.svg';
import { toast } from "react-toastify";
import NotificationModal from "HELPDESK/CommonResources/NotificationPanel/NotificationModal/NotificationModal";
import { X } from 'lucide-react';


function NotificationPanel(props) {

    let shouldWait = false;
    let scrollBuffer = 0;

    const [showPanel, setShowPanel] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [limit, setLimit] = useState(10);
    const [pageIndex, setPageIndex] = useState(1);
    const [offset, setOffset] = useState(0);
    const [sortedIdArray, setSortedIdArray] = useState([]);
    const [selectedIdArray, setSelectedIdArray] = useState([]);
    const [totalCount, setTotalCount] = useState([]);
    const [notificationList, setNotificationList] = useState([]);
    const [unReadMessageCount, setUnReadMessageCount] = useState([]);
    const [currentNotification, setCurrentNotification] = useState('Notifications');
    const [updateList, setUpdateList] = useState([]);
    const [updatesUnreadCount, setUpdatesUnreadCount] = useState(0);
    const [releaseID, setReleaseId] = useState(null);
    const [releaseNotificationModalOpen, setReleaseNotificationModalOpen] = useState(false);
    const [currentReleaseDetailsData, setCurrentReleaseDetailsData] = useState({});
    const [isUpdateLoading, setIsUpdateLoading] = useState(false);
    const [updatesLimit, setUpdateLimit] = useState(10);
    const [totalUpdatesCount,setTotalUpdatesCount] = useState(0);

    const [notificationFeature, setNotificationFeature] = useState([{
        id: 1,
        title: 'Notifications',
    }, {
        id: 2,
        title: 'Updates',
    }]);
    // const modalRef = useRef(null);
    const modalARef = useRef(null);
    const modalBRef = useRef(null);

    const AdminAccessInstituteArray = useSelector((state) => state?.RouteMenuReducer?.assignedIIDArray || []);
    

    useEffect(() => {
        // if currentNotification == 'Updates'
        if (currentNotification == 'Updates') {
            apiCallToGetReleaseDetails();
        }
        if (currentNotification == 'Notifications') {
            apiCallToGetWebNotification();
        }
    }, [currentNotification, limit, updatesLimit,releaseNotificationModalOpen])

    useEffect(() => {

        if (props.notificationModal != showPanel) {

            setShowPanel(props.notificationModal)
        }
    }, [props.notificationModal]);

    // useEffect(() => {
    //     apiCallToGetWebNotification();
    // }, [limit]);

    const apiCallToGetReleaseDetails = async () => {
        const requestData = {
            userId: config.faculty_id,
            iid: config.institute_id,
            pageIndex: 0,
            limitPerPage: updatesLimit,


        };
        try {
            const jsonResponse = await HelpdeskApiCall.makeApiCall(
                'pmTool_getSummaryNotificationCount',
                requestData,
                "/api/projectManagement/Queries/pmTool_DocSEMDashBoard.php"
            );
            if (jsonResponse.expired) {
                setTimeout(() => {
                    apiCallToGetReleaseDetails();
                }, 1000);
            } else {
                if (jsonResponse.success) {
                    if (jsonResponse.APIResult.status === 'fail') {
                        // setUpdatesUnreadCount(jsonResponse.APIResult.unreadNotificationCount);     
                        setUpdateList([])
                        toast.info(jsonResponse.APIResult.message)
                    } else {


                        let totalUpdatesCount = jsonResponse.APIResult.unreadNotificationCount + jsonResponse.APIResult.readNotificationCount;
                        setTotalUpdatesCount(totalUpdatesCount);

                              let sortedKey=jsonResponse.APIResult.sorted_key
                              let updatesArray = []
                              sortedKey.map((uid) => {
                                updatesArray.push(jsonResponse.APIResult.data[uid])
                            })

                        setUpdateList(updatesArray)
                        // setUpdatesUnreadCount(jsonResponse.APIResult.data.unreadNotificationCount);

                    }



                } else {
                    toast.error("Something went wrong While getting Announcements")
                }
            }
        } catch (error) {
            toast.error('Something went wrong While getting Announcements:', error);
        }
    };





    // FUNCTION TO LOAD MORE
    let loadMore = () => {
        setLimit((prev) => prev + 10);
    }
    let loadUpdatesMore = () => {
        setUpdateLimit((prev) => prev + 10);
    }




    const handleShowPanel = () => {
        showPanel && setShowPanel(false)


    };

    // window.addEventListener(
    //     'click',
    //     event => !document.getElementById('notification-container-99').contains(event.target) && handleShowPanel()
    // );

    // const handleScroll = () => {
    //     let offsetHeight = document.getElementById('notification-container-99').offsetHeight;
    //     let scrollTop = document.getElementById('notification-container-99').scrollTop;

    //     if (scrollTop == 0) { scrollBuffer = 0; }

    //     if (((scrollTop - (scrollBuffer)) <= 0) || (Math.floor(offsetHeight / 3) > scrollTop)) return;

    //     scrollBuffer = scrollTop;
    // }



    //  API CALL TO GET NOTIFICATION
    const apiCallToGetWebNotification = async () => {
        setIsLoading(true);
        let formData = {
            iid: config.institute_id,
            // userRole: config.instructorRole == "instructor" || config.instructorRole == "employee" || config.instructorRole == "teaching" || config.instructorRole == "nonteaching" ? "instructor" : "learner",
            userRole: "instructor", //config.instructorInfo.account == "faculty" || config.instructorInfo.account == "instructor" || config.instructorInfo.account == "employee" || config.instructorInfo.account == "teaching" || config.instructorInfo.account == "nonteaching" ? "instructor" : "learner",
            userId: config.faculty_id,
            offset: offset,
            limit: limit,
            iidArray: props.instituteIdArray
        };
        let jsonResponse = await HelpdeskApiCall.makeApiCall(
            "webNotificationGetNotification",
            formData,
            '/api/webNotification/webNotification.php'
        );
        if (jsonResponse.expired) {
            setTimeout(() => {
                apiCallToGetWebNotification();
            }, 1000);
        } else {
            if (jsonResponse.success) {
                let apiResult = jsonResponse.APIResult.data;
                let unReadMessageCount = jsonResponse.APIResult.unReadMessageCount;
                let totalCount = jsonResponse.APIResult.totalCount;
                setUnReadMessageCount(unReadMessageCount);
                setNotificationList(apiResult);
                setIsLoading(false);
                setSortedIdArray(jsonResponse.APIResult.sortedIdArray);
                setTotalCount(totalCount);
                setSelectedIdArray([]);
            } else {
                setIsLoading(true);
            }
        }


    }

    //  API CALL TO UPDATE NOTIFICATION
    const apiCallToUpdateWebNotification = async (uniqueId) => {
        if (!selectedIdArray.includes(uniqueId)) {
            setSelectedIdArray([...selectedIdArray, uniqueId]);
        }

        let formData = {
            iid: config.institute_id,
            uniqueId: uniqueId,
            userId: config.faculty_id,
        };
        let jsonResponse = await HelpdeskApiCall.makeApiCall(
            "webNotificationUpdateNotification",
            formData,
            '/api/webNotification/webNotification.php'
        );
        if (jsonResponse.expired) {
            setTimeout(() => {
                apiCallToUpdateWebNotification();
            }, 1000);
        } else {
            if (jsonResponse.success) {

                let apiResult = jsonResponse.APIResult;
                // let notificationListTemp = notificationList;
                // if(jsonResponse.APIResult.status == "success")
                // {
                //     notificationListTemp.map((notification) => {

                //         if(uniqueId == notification.uniqueId)
                //        {
                //            notification.isRead = "true"
                //        }
                //    })

                //    setNotificationList(notificationListTemp);
                // }
                apiCallToGetWebNotification();
            }
        }

    }

    const getFirstCharOfWords = (inputString) => {
        const wordsArray = inputString.split(' ');
        const firstCharsArray = wordsArray.map((word) => word.charAt(0));
        const result = firstCharsArray.join('');
        return result;
    }

    const handleNotificationType = (value) => {
        setCurrentNotification(value);
    }

    const validateUpdateReleaseStatus = (releaseId, releaseDetails, isReadNotification) => {
        // if (isReadNotification == "false") {
        //     apiCallToUpdateReleaseRead(releaseId);
        // }
        setCurrentReleaseDetailsData(releaseDetails)
        setReleaseId(releaseId);
        setReleaseNotificationModalOpen(true);
    }

    const handleClickOutside = (event) => {
        if (
            modalARef.current &&
            !modalARef.current.contains(event.target) &&
            (!modalBRef.current || !modalBRef.current.contains(event.target)) // <-- check modal B too
        ) {
            props.handleModalOpenClose('notification');
        }
    };


    useEffect(() => {

        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, []);

    return (
        <>
            <div className={props.notificationModal ? "modal fade show" : "modal fade"} id="modalContainer" style={{ display: props.notificationModal ? 'block' : 'none' }}>
                <div
                    className="modal-content workspace-current-modal-mode notification-mobile-mode"
                    style={{
                        position: "absolute",
                        top: "3rem",
                        right: "0",
                        padding: '20px',
                        zIndex: 9999,
                        width: '30vw',
                        minWidth: '30vw',
                        height: "calc(100vh - 3rem)",
                        overflowY: 'auto',


                    }}
                    ref={modalARef}

                >

                    <div style={{ display: 'flex', justifyContent: "space-between", paddingBottom: '10px' }}>
                        <div className="customization-tabs vm-ws-default-theme" style={{ paddingBottom: '10px' }}>

                            {
                                notificationFeature.map((notification) => {
                                    return (
                                        <p key={notification.id} className={`vm_custom_subtitle5 customization-tab ${notification.title == currentNotification ? 'vm-ws-selected-tab' : ''}`} onClick={() => handleNotificationType(notification.title)}>{notification.title}</p>
                                    )
                                })
                            }
                        </div>
                        <div className="config-icon-background-rounded cursor-pointer" onClick={() => props.handleModalOpenClose("notification")}>
                            <X size={18} />
                        </div>

                    </div>


                    {currentNotification === 'Notifications' &&
                        <div
                            className='pr-2 mt-1 d-flex flex-column scrollable'
                            style={{ height: 'calc(100% - 100px)' }}
                        >
                            {
                                notificationList.length === 0
                                    ?
                                    <span>No new notifications.</span>
                                    :
                                    <>
                                        {
                                            sortedIdArray?.map((id) => {
                                                let notification = notificationList[id];
                                                if (notification) {
                                                    const firstChars = getFirstCharOfWords(notification.userName);
                                                    return (
                                                        <div key={notification.uniqueId} className={`ws-vm-cell-notification p-1 px-2 d-flex ${!notification.isRead ? 'light-grey-fill' : ''}`} style={{ borderRadius: '0.8rem', cursor: 'pointer' }}
                                                            onClick={() => {
                                                                if (!selectedIdArray.includes(notification.uniqueId) && notification.isRead == "false") {
                                                                    apiCallToUpdateWebNotification(notification.uniqueId);
                                                                }
                                                            }}
                                                            disabled={selectedIdArray.includes(notification.uniqueId)}
                                                        >
                                                            <span
                                                                className="poppins-typography mt-2 mr-3 p-1 d-flex align-items-center justify-content-center ws-fwm-icon-color"
                                                                style={{ height: '30px', width: '30px', borderRadius: '50%', backgroundColor: '#808080' }}
                                                                title={notification.userName}
                                                            >
                                                                {firstChars}

                                                            </span>

                                                            <div className="w-75 flex-grow-1 d-flex flex-column" style={{ fontSize: '13px' }}>
                                                                <span className="poppins-typography font-weight-bold">{notification.moduleName}</span>
                                                                <p className="poppins-typography vm_custom_caption">
                                                                    {notification.addedOnDateTime}&nbsp;

                                                                </p>
                                                                <span className="poppins-typography">
                                                                    {notification.notificationText}
                                                                </span>
                                                                <div className="mt-1 d-flex justify-content-between">
                                                                    <span className="font-weight-bold">{ }</span>
                                                                    <span className="text-black-50" style={{ fontSize: '12px' }}>
                                                                        <img src={notification.isRead == "false" ? CHECK : DOUBLE_CHECK} alt="" />
                                                                    </span>
                                                                </div>


                                                            </div>
                                                        </div>
                                                    )
                                                }
                                            })
                                        }
                                        {
                                            isLoading
                                                ?
                                                (<span className="align-self-center font-weight-bold text-black-50">
                                                    Loading more . . .&nbsp;
                                                    <FontAwesomeIcon icon={['fas', 'circle-notch']} className="rotate" />
                                                </span>)
                                                :
                                                <>
                                                    {totalCount != sortedIdArray.length &&
                                                        <span
                                                            className="align-self-center font-weight-bold ui-link"
                                                            onClick={() => limit >= 10 && loadMore()}
                                                        >Load more</span>}
                                                </>
                                        }
                                    </>
                            }
                        </div>
                    }
                    {currentNotification === 'Updates' &&
                        <div
                            className='pr-2 mt-1 d-flex flex-column scrollable'
                            style={{ height: 'calc(100% - 100px)' }}
                        >
                            {
                                updateList?.length === 0
                                    ?
                                    <span key={1}>No New Updates.</span>
                                    :
                                    <>
                                        {
                                            updateList?.map((update) => (
                                                <>
                                                    {
                                                        Object.values(update?.releaseData).length > 0 &&
                                                        <div key={update.releaseData.sprintId} className={`ws-vm-cell-notification mb-2 p-3 d-flex ${!update.readNotification ? 'light-grey-fill' : ''}`} style={{ borderRadius: '0.8rem', cursor: 'pointer' }}
                                                            onClick={() => {
                                                                // if (update.readNotification == "false") {
                                                                validateUpdateReleaseStatus(update.releaseData.sprintId, update.releaseData, update.readNotification);
                                                                // }
                                                            }}
                                                        >
                                                            <span
                                                                className="mt-2 mr-3 p-1 d-flex align-items-center justify-content-center ws-fwm-icon-color"
                                                                style={{ height: '30px', width: '30px', borderRadius: '50%', backgroundColor: '#808080' }}
                                                                title={update.releaseData.addedByName}
                                                            >
                                                                {update.releaseData.addedByName?.charAt(0)}
                                                            </span>

                                                            <div className="w-75 flex-grow-1 d-flex flex-column" style={{ fontSize: '13px' }}>

                                                                <span className="font-weight-bold">{update.releaseData.sprintId + " - " + update.releaseData.title} </span>

                                                                <p className="vm_custom_caption">
                                                                    {update.releaseData.addedOn}&nbsp;
                                                                </p>
                                                                <span>
                                                                    {update.releaseData.moduleName}
                                                                </span>
                                                                <div className="mt-1 d-flex justify-content-between">
                                                                    <span className="poppins-typography" style={{ fontSize: '10px' }}>{"Service Request Count : " + update.releaseData.totalQueries}</span>
                                                                    <span className="text-black-50" style={{ fontSize: '12px' }}>
                                                                        <img src={update.readNotification === "false" ? CHECK : DOUBLE_CHECK} alt="update.readNotification" />
                                                                    </span>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    }
                                                </>
                                            ))
                                        }

                                        {
                                            isUpdateLoading
                                                ?
                                                (<span className="align-self-center font-weight-bold text-black-50">
                                                    Loading Updates . . .&nbsp;
                                                    <FontAwesomeIcon icon={['fas', 'circle-notch']} className="rotate" />
                                                </span>)
                                                :
                                                <>
                                                    {totalUpdatesCount != updateList?.length &&
                                                        <span
                                                            className="align-self-center font-weight-bold ui-link"
                                                            onClick={() => updatesLimit >= 10 && loadUpdatesMore()}
                                                        >Load more Updates</span>}
                                                </>
                                        }
                                    </>
                            }

                        </div>
                    }


                </div>
            </div >
            {
                releaseNotificationModalOpen && <NotificationModal
                    releaseNotificationModalOpen={releaseNotificationModalOpen}
                    releaseID={releaseID}
                    currentTeam={currentReleaseDetailsData}
                    currentRelease={currentReleaseDetailsData}
                    onClose={() => setReleaseNotificationModalOpen(false)}
                    modalRef={modalBRef}
                />
            }
        </>
    );
}

export default NotificationPanel;
